import forOwn from 'lodash/forOwn';
import { makeRequest } from '../../../../lib/api';
import {
  GetOrderInvoiceDocumentsRequest,
  EditOrderInvoiceDocumentsRequest,
  CreateOrderInvoiceDocumentsRequest,
} from '../../api/documentApi';

const ORDER_INVOICES_PATH = '/v1/order_invoice_documents';

const invoiceDocumentController = {
  getOrderInvoiceDocuments: (request: GetOrderInvoiceDocumentsRequest): Promise<any> => {
    return makeRequest('get', `${ ORDER_INVOICES_PATH }?orderInvoiceId=${ request.orderInvoiceId }&showDeleted=${ request.showDeleted ? 'true' : 'false' }`);
  },
  createOrderInvoiceDocuments: (request: CreateOrderInvoiceDocumentsRequest): Promise<any> => {
    if (!request?.file) delete request?.file;
    if (!request?.externalUrl) delete request?.externalUrl;
    if (!request?.comment) delete request?.comment;
    const form = new FormData();
    forOwn(request, (value, key) => {
      return form.append(key, typeof value === 'number' ? value.toString() : value);
    });
    return makeRequest('post', ORDER_INVOICES_PATH, form);
  },
  editOrderInvoiceDocuments: (id: string, request: EditOrderInvoiceDocumentsRequest): Promise<any> => {
    if (!request?.comment) delete request?.comment;
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }`, request);
  },
  deleteOrderInvoiceDocuments: (id: string): Promise<any> => {
    return makeRequest('delete', `${ ORDER_INVOICES_PATH }/${ id }`);
  },
};

export { invoiceDocumentController };
